/* tslint:disable */
/* eslint-disable */
/**
 * V2M Backend API
 * Backend API for the V2M multi-brand platform (word2mail, koe2mail, sprich2mail, ...) - handles authentication, quota management, and LLM requests
 *
 * The version of the OpenAPI document: 1.0.5
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the RateGenerationResponse interface.
 */
export function instanceOfRateGenerationResponse(value) {
    if (!('bonusEarned' in value) || value['bonusEarned'] === undefined)
        return false;
    if (!('bonusGenerations' in value) || value['bonusGenerations'] === undefined)
        return false;
    if (!('ratingsUntilNextBonus' in value) || value['ratingsUntilNextBonus'] === undefined)
        return false;
    if (!('status' in value) || value['status'] === undefined)
        return false;
    return true;
}
export function RateGenerationResponseFromJSON(json) {
    return RateGenerationResponseFromJSONTyped(json, false);
}
export function RateGenerationResponseFromJSONTyped(json, _ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'bonusEarned': json['bonusEarned'],
        'bonusGenerations': json['bonusGenerations'],
        'ratingsUntilNextBonus': json['ratingsUntilNextBonus'],
        'status': json['status'],
    };
}
export function RateGenerationResponseToJSON(json) {
    return RateGenerationResponseToJSONTyped(json, false);
}
export function RateGenerationResponseToJSONTyped(value, _ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'bonusEarned': value['bonusEarned'],
        'bonusGenerations': value['bonusGenerations'],
        'ratingsUntilNextBonus': value['ratingsUntilNextBonus'],
        'status': value['status'],
    };
}
